// Export the Component Definition for use in Contentful Studio
export {TestimonialContentfulComponentDefinition} from './TestimonialContentfulDefinition';
export {default} from './Testimonial';
